import getLocalString from "constants/Localization";
import { useUpdateJobExternalIdMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateJobExternalId() {
  const [mutation, { loading, data, error }] = useUpdateJobExternalIdMutation({
    refetchQueries: ["getJob", "getJobs"],
  });
  const [updateJobExternalId, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateJobExternalId",
    },
    {
      successMessage: getLocalString("jobs.update-job-external-id-success"),
      failureMessage: getLocalString("jobs.update-job-external-id-failure"),
    }
  );

  return [updateJobExternalId, context] as const;
}
